import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus, { ElMessage } from 'element-plus';
import 'element-plus/dist/index.css';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import zhTw from 'element-plus/dist/locale/zh-tw.mjs';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import mergeRoutesByUser from '@/router';
import { initRouter } from '@/router/hook';
import { login, getUserMenu, getUserInfo, getLoginInit, setLoginInit } from '@/lib/helpers/user';
import { getPlatformType } from '@/lib/helpers/platform';
import request from '@/lib/request';
import errReport from '@/lib/errReport';
import bigDataInit from '@/lib/bigDataTrack';

import { initSocket, retryReconnectInterval } from '@/lib/websocket';
import Directive from '@/lib/directives';
import { rootStore } from '@/store/rootStore';
import { menuListStore } from '@/store/menuListStore';
import { isWechatBrowser } from '@/lib/utils';

declare global {
  interface Window {
    VConsole: any;
    RouterInstance: any;
    sense: any;
  }
}
if (import.meta.env.VITE_ENV !== 'production') {
  isWechatBrowser && new window.VConsole();
}
login().then(async (readyToGetInfo) => {
  let userName = '';
  // readyToGetInfo 是否可以获取用户信息
  const pinia = createPinia();
  const app = createApp(App);
  app.use(pinia);
  let userMap: string[] = [];
  if (readyToGetInfo) {
    userMap = await getUserMenu();
    userName = await getUserInfo();
    getPlatformType();
    initSocket();
    retryReconnectInterval();
    if (getLoginInit() === 'unify_login') {
      const menuListStoreEx = menuListStore();
      menuListStoreEx.clearKeepAlivePath();
      setLoginInit('');
    }
  }
  const mergeRoutes = mergeRoutesByUser(userMap);
  const router = createRouter({
    history: createWebHistory('/'),
    routes: mergeRoutes,
  });
  initRouter(router);

  app.config.globalProperties.$http = request;
  app.config.globalProperties.$message = ElMessage;
  app.config.errorHandler = (err: any, vm) => {
    let { message, name, stack } = err;

    if (message || name) {
      errReport({
        type: 'runtime',
        target: `组件：${vm?.$options?.__name}，触发用户：${userName}`,
        message: `${name}:${message}`,
        trace: stack.toString() ? stack.toString() : name && message ? `${name}:${message}` : '',
        from: 'vue.config.errorHandler',
      });
    }
    console.error(err);
  };
  app.use(router);

  app.use(Directive);
  app.use(ElementPlus, {
    locale: zhTw,
  });
  rootStore();
  app.mount('#app');
  bigDataInit();
});
